const FooterData = [
    {
        header: "Product",
        text1: "Overview",
        text2: "Features",
        text3: "Solutions",
        text4: "Tutorials",
        text5: "Pricing",
        text6: "Releases",
        new: "true"
    },
    {
        header: "Company",
        text1: "About us",
        text2: "Careers",
        text3: "Press",
        text4: "News",
        text5: "Media Kit",
        text6: "Contact",
        new: "false"
    },
    {
        header: "Product",
        text1: "Projects",
        text2: "Projects",
        text3: "Projects",
        text4: "Projects",
        text5: "Projects",
        text6: "Projects",
        new: "false"
    },
    {
        header: "Product",
        text1: "Projects",
        text2: "Projects",
        text3: "Projects",
        text4: "Projects",
        text5: "Projects",
        text6: "Projects",
        new: "false"
    },
    {
        header: "Product",
        text1: "Projects",
        text2: "Projects",
        text3: "Projects",
        text4: "Projects",
        text5: "Projects",
        text6: "Projects",
        new: "false"
    },  
]
export default FooterData